import {createNode} from "./common/ui";

(function () {
	function init() {
		function initUi() {
			const shopCountriesRadios = document.querySelectorAll('[name=countries__country]');

			function shopShopNodeFrom(shop) {
				const categoryShop = createNode('li', 'shops__category-shop');
				const categoryShopCard = shop.hasDetailedPage
					? createNode(
						'a',
						'shops__category-shop-card',
						{
							href: `/shops/${shop.id}.html`,
							title: `${shop.name}`,
						})
					: createNode(
						'a',
						'shops__category-shop-card',
						{
							href: `${shop.link}`,
							title: `${shop.name}`,
							target: '_blank',
						});

				const cardLogo = createNode('div', 'shops__category-shop-logo');
				if (!!shop.vpn) {
					const cardLogoBadge = createNode(
						'span',
						'shops__category-shop-logo-badge',
						{
							title: 'Для доступа в магазин понадобится VPN',
							innerText: 'VPN',
						})
					cardLogo.appendChild(cardLogoBadge);
				}
				const cardLogoPicture = createNode('picture');
				const cardLogoSource = createNode(
					'source',
					undefined,
					{
						srcset: `/images/webp/shops/${shop.logoWebp}, /images/webp/shops/${shop.logoWebp2x} 2x, /images/webp/shops/${shop.logoWebp3x} 3x`,
						type: 'image/webp'
					}
				);
				const cardLogoImg = createNode(
					'img',
					undefined,
					{
						src: `/images/shops/${shop.logo}`,
						srcset: `/images/shops/${shop.logo}, /images/shops/${shop.logo2x} 2x, /images/shops/${shop.logo3x} 3x`,
						alt: shop.name,
						loading: 'lazy'
					}
				)
				cardLogoPicture.appendChild(cardLogoSource);
				cardLogoPicture.appendChild(cardLogoImg);
				cardLogo.appendChild(cardLogoPicture);

				const shopName = createNode('span', 'shops__category-shops-shop-name', {innerText: shop.name});

				const shopLink = createNode(
					'span',
					'button button--primary button--accent shops__category-shops-shop-link',
					{
						innerText: 'В магазин',
					});

				categoryShopCard.appendChild(cardLogo);
				categoryShopCard.appendChild(shopName);
				categoryShopCard.appendChild(shopLink);
				categoryShop.appendChild(categoryShopCard);

				return categoryShop;
			}

			function replaceShopsWith(sourceList) {
				return new Promise(resolve => {
					for (let source of sourceList) {
						const shopList = document.querySelector(`.shops__category-shops-category#${source.category.id} .shops__category-shops-list`);
						shopList.innerHTML = '';
						for (let shop of source.shops) {
							shopList.appendChild(shopShopNodeFrom(shop));
						}
					}
					resolve();
				})
			}

			function loadShops(countryIsoCode, categories, loadShopsHandler) {
				return new Promise(resolve => {
					const promises = [];

					for (let category of categories)
						promises.push(loadShopsHandler(countryIsoCode, category))

					Promise.all(promises).then(resolve);
				})
			}

			return {
				onCountryClick: function (loadCategoriesHandler, loadShopsHandler) {
					for (let countryRadio of shopCountriesRadios) {
						countryRadio.addEventListener('change', function () {
							loadCategoriesHandler(countryRadio.value)
								.then((categories) => {
									loadShops(countryRadio.value, categories, loadShopsHandler)
										.then((data) => {
											replaceShopsWith(data).then(_ => {
												document.dispatchEvent(new Event('scroll'));
											});
										})
								});
						});
					}
				},
			};
		}

		function initApi() {
			const random = Math.floor(Math.random() * 10000000000000000);
			return {
				fetchCategories: function (countryIsoCode) {
					return new Promise((resolve, reject) => {
						fetch(`/get/${countryIsoCode}/shopsCategories.json?${random}`)
							.then(response => {
								response.json().then(resolve).catch(reject);
							})
							.catch(reject);
					});
				},
				fetchShops: function (countryIsoCode, category) {
					return new Promise((resolve, reject) => {
						fetch(`/get/${countryIsoCode}/shops__${category.id}.json?${random}`)
							.then(response => {
								response.json().then((data) => {
									resolve({category: category, shops: data})
								}).catch(reject);
							})
							.catch(reject);
					});
				}
			};
		}

		function initBehaviour(ui, api) {
			const loadCategoriesHandler = countryIsoCode => api.fetchCategories(countryIsoCode);
			const loadShopsHandler = (countryIsoCode, category) => api.fetchShops(countryIsoCode, category);

			ui.onCountryClick(loadCategoriesHandler, loadShopsHandler);
		}

		const ui = initUi();
		const api = initApi();
		initBehaviour(ui, api);
	}

	document.addEventListener('DOMContentLoaded', function () {
		init();
	});
})();
